import React, { useState, useEffect } from 'react';
import '../css/Testimonials.css';
import asset from '../assets/images'

const Testimonials = () => {
  const testimonials = [
    {
      name: "Dineshika Kumari ",
      feedback: "They made everyone feel comfortable in front of the camera and managed to capture all the candid emotions, joy, and little details that made the day so special.",
      image: asset.t1,
    },
    {
      name: "Midumi Ahinsa ",
      feedback: "Highly Recommended. We had the absolute pleasure of having Priyantha Bandara Photography capture my sister’s wedding, and I must say, every moment was beautifully documented beyond our expectations.",
      image: asset.t2,
    },
    {
      name: "Samadi Dilshani ",
      feedback: "If you’re looking for someone who genuinely understands the art of storytelling through lens Priyantha Bandara is definitely the one. Thank you once again for creating timeles memories for our famiy!",
      image: asset.t3,
    },
    {
      name: "Darrell Mejant",
      feedback: "Piyantha Bandar was the best photographer We have ever hired for my friends wedding. On time. Followed through on everything he said he would do. Would highly recommend him to family, friends and business associates.",
      image: asset.t4,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  // Auto slide testimonials every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000); // Change every 4 seconds
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="testimonials-luxury-section">
      <h2 className="main-services-title">Client feedback</h2>
      <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
      <div className="testimonials-luxury-cards">
        {testimonials.map((item, index) => (
          <div
            key={index}
            className={`testimonials-luxury-card ${index === activeIndex ? 'active' : ''}`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <div className="testimonials-luxury-image-wrapper">
              <img src={item.image} alt={item.name} className="testimonials-luxury-image" />
            </div>
            <p className="testimonials-luxury-feedback">"{item.feedback}"</p>
            <div className="testimonials-luxury-client">
              <h3 className="testimonials-luxury-name">{item.name}</h3>
              <p className="testimonials-luxury-title-client">{item.title}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
